var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from 'syf-component-library/ui/spacing';
import { Body } from 'syf-component-library/ui/typography';
import triggerAnalyticsEvent from '../../../helpers/triggerAnalytics';
import { PAGE_NAMES, TROUBLE_IN_GETTING_DATA } from '../../../const/analytics';
import IMAGE_ASSET_PATHS from '../../../const/assets';
import { CenterStackedInset, ErrorImg, FullHeightContainer, Subtitle } from './subcomponents';
var ErrorPage = function (_a) {
    var config = _a.config, analyticsEventOptions = _a.analyticsEventOptions;
    var t = useTranslation().t;
    var assets = config.hosts.assets;
    useEffect(function () {
        triggerAnalyticsEvent(__assign({ messageType: PAGE_NAMES.API_FAIL, pageName: PAGE_NAMES.API_FAIL.toLowerCase(), message: TROUBLE_IN_GETTING_DATA, errorMessage: t('errorPage.description', { lng: 'en' }) }, analyticsEventOptions));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsx(FullHeightContainer, { children: _jsxs(CenterStackedInset, __assign({ all: "xlarge" }, { children: [_jsx(ErrorImg, { src: "".concat(assets.origin, "/").concat(IMAGE_ASSET_PATHS.ERROR_IMAGE), alt: "Error" }), _jsx(Stack, { size: "xlarge" }), _jsx(Subtitle, __assign({ as: "h1", weight: "bold" }, { children: t('errorPage.description') })), _jsx(Stack, { size: "small" }), _jsx(Body, { children: t('errorPage.tryAgain') })] })) }));
};
export default ErrorPage;
